import axios from '@/http/axios';

export default {
  fetchList: (config: any = {}) => {
    return axios.get(`/service-items`, config);
  },
  discountRuleForBusiness: (oid, config: any = {}) => {
    return axios.put(
      `/service-items/${oid}/discount-rule-for-business`,
      config
    );
  },
};
